import http from "../../http-common";

const getGroups = (user, company) => {
  return http.get(`/api/v1/teams/groups?user=${user}&company=${company}`);
};

const getAgents = (groupName, username) => {
  return http.get(
    `/api/v1/teams/agents/?groupName=${groupName}&user=${username}`
  );
};

const getAgentsArraySimple = (groupName) => {
  return http.get(`/api/v1/teams/agents/simple?groupName=${groupName}`);
};

const postNewGroup = (body) => {
  return http.post("/api/v1/teams/groups", body);
};

const getAllAgentsStatus = (body, pToken) => {
  return http.post(`/api/v1/teams/agents/status?pToken=${pToken}`, {
    users: body,
  });
};

const getAgentCallStatus = (agentId, username) => {
  return http.get(
    `/api/v1/teams/agents/status/call?agentId=${agentId}&user=${username}`
  );
};

const getRealtimeGroupSelected = (group, token, username, company) => {
  console.log("En el realtime GroupSelected");
  return http.get(
    `/api/v1/teams/realtime/queuestats?limit=99999&queueName=${group}&token=${token}&username=${username}&company=${company}`
  );
};

const getAgentsList = (groupName) => {
  return http.get(`/api/v1/teams/agents/simple?groupName=${groupName}`);
};
const postSpyCall = (channel, spy, company, extension) => {
  return http.post(
    `/api/v1/teams/calls/spyCall?spied=${channel}&spy=${spy}&company=${company}&extension=${extension}`
  );
};

const RealTimeService = {
  getGroups,
  getAgents,
  getAgentsArraySimple,
  postNewGroup,
  getAllAgentsStatus,
  getAgentCallStatus,
  getRealtimeGroupSelected,
  getAgentsList,
  postSpyCall,
};

export default RealTimeService;
